import queryString from 'querystring-es3';

export default {
  filterProps: {
    assembly: [],
    brand: [],
    product_group: [],
  },
  parentSelector: '.custom-product-filters',
  initArchiveFilter() {
    this.initBindings();

    this.setFilterPropsFromURL();

    // this.updateSelectedFilterTags();
    this.initSelectedFilters();
  },
  initBindings() {

    this.bindCloseHandlers();

    $('.custom-prod-filter__title').on('click', (event => {
      const $self = $(event.target).closest('.custom-prod-filter__title');
      const $filterTitle = $('.custom-prod-filter > .custom-prod-filter__title');
      const $filterOptions = $self.closest('.custom-prod-filter').find('.custom-prod-filter__content');

      $('.custom-prod-filter__content').removeClass('active');
      $('.custom-prod-filter__title').removeClass('active');

      let $contentWrapper = $('.custom-prod-filter__content');
      let product_cat_id = $filterTitle.data('product-cat-id');
      let external_slug = $filterTitle.data('external-slug');

      if($self.hasClass('initial')) {
        let postData = {
          'taxonomy': 'assembly',
          'level': 0,
          'label': 'Test Label 0',
          'product_cat_id': product_cat_id,
          'external_slug': external_slug,
          'parent_slug': external_slug,
          // '_wpnonce': admin_url['filter_nonce'],
        };

        console.trace({external_slug});
        // if this category has children show sub menu

        $contentWrapper.addClass('loading');

        jQuery.ajax({
          url: admin_url['filter_endpoint'],
          type: 'post',
          data: postData,
          success: result => {
            $contentWrapper.append(result.content);
            $contentWrapper.removeClass('loading');
            $self.removeClass('initial')
          },
          error: function (error) {
            console.log('error when fetching template for subcategory', error);
            $contentWrapper.removeClass('loading');
          },
        });
      }

      if (!$filterOptions.hasClass('active')) {
        $filterOptions.addClass('active');

        $self.addClass('active');
      }
    }));

    $('body').on('click', this.parentSelector + ' .custom-prod-filter .filter-option', event => {
      const $filterTitle = $('.custom-prod-filter > .custom-prod-filter__title');
      let $el = $(event.target).closest('.filter-option');
      let id = $el.data('id');
      let product_cat_id = $filterTitle.data('product-cat-id');
      let name = $el.data('name');
      let filterBy = $el.data('filter-by');
      let slug = $el.data('slug');
      let level = $el.closest('.filter-options').first().data('level');
      let path = $el.closest('.filter-options').first().data('path-name');
      let label = (path !== null && path !== '' ? path + ' / ' : '') + name;
      let $contentWrapper = $el.closest('.custom-prod-filter__content');
      let external_slug = $filterTitle.data('external-slug');

      console.trace({external_slug});

      let postData = {
        'id': id,
        'taxonomy': filterBy,
        'level': level,
        'label': label,
        'parent_slug': slug,
        'product_cat_id': product_cat_id,
        'external_slug': external_slug,
        // '_wpnonce': admin_url['filter_nonce'],
      };

      // if this category has children show sub menu
      if ($el.hasClass('has-children')) {
        $contentWrapper.addClass('loading');
        let old_content = $contentWrapper.html();
        // $contentWrapper.empty();

        jQuery.ajax({
          url: admin_url['filter_endpoint'],
          type: 'post',
          data: postData,
          success: result => {
            $contentWrapper.append(result.content);
            $contentWrapper.removeClass('loading');

            let $addedFilterOptions = $contentWrapper.find('.filter-options-menu--level-' + (level + 1));
            this.updateFilterOptionsActiveStates($addedFilterOptions, filterBy);
          },
          error: function (error) {
            console.log('error when fetching template for subcategory', error);
            $contentWrapper.removeClass('loading');
            $contentWrapper.html(old_content);
          },
        });
      } else {
        this.filterProps[filterBy].push(slug);
        this.updateFilters();
      }
    });
  },
  updateFilterOptionsActiveStates($filterOptions, filterBy) {

    this.filterProps[filterBy].forEach(filterProp => {
      $filterOptions.find('[data-name="' + filterProp + '"]').each((index, filterOption) => {
        $(filterOption).addClass('active');
      })
    });
  },
  bindCloseHandlers() {
    $('body').on('click', '.filter-options .filter-btn-close', event => {
      event.stopPropagation();

      let $openMenu = $(event.target).closest('.filter-options');

      // if we close the "top" -menu also remove the active state from the menu title button
      if ($openMenu.hasClass('filter-options-menu--level-0') || $openMenu.hasClass('filter-options-menu--level-1')) {
        $('.custom-prod-filter__title').removeClass('active');
        $('.custom-prod-filter__content').removeClass('active');
      } else {
        $openMenu.remove();
      }

    });

    // Also listen to clicks outside of the box to close
    // $('body').on('click', e => {
    //   if (jQuery(this.parentSelector).is(":visible")) {
    //     let isClickOutsideOfFilterBox = $(this.parentSelector).find(e.srcElement).length === 0;

    //     if (isClickOutsideOfFilterBox) {
    //       $('.custom-prod-filter__content.active .filter-options').each(function ($activeMenu) {
    //         $activeMenu = $(this);

    //         if ($activeMenu.hasClass('filter-options-menu--level-0')) {
    //           $('.custom-prod-filter__title').removeClass('active');
    //           $('.custom-prod-filter__content').removeClass('active');
    //         } else {
    //           $activeMenu.remove();
    //         }
    //       })
    //     }
    //   }
    // })
  },
  updateFilters() {
    this.updateURLFilters();
    // also update selectd filters if we switch to ajax later
    // this.updateSelectedFilterTags();
  },
  updateURLFilters() {
    let preparedFilterProps = [];

    Object.keys(this.filterProps).forEach(key => {
      if (this.filterProps[key].length > 0) {
        preparedFilterProps['tax_' + key] = this.filterProps[key].join(',');
      }
    });

    let searchString = queryString.stringify(preparedFilterProps);

    // todo: needs update!!!
    let urlParts = window.location.href.split('/') // .splice(0, length -2 )

    // is paginated => remove pagination
    if (urlParts[urlParts.length - 2] === 'page') {
      let url = urlParts.splice(0, urlParts.length - 2).join('/');
      window.location = url + '?' + searchString;
    } else {
      window.location.search = searchString;
    }
  },
  // updateSelectedFilterTags () {
  //   Object.keys(this.filterProps).forEach(key => {
  //     const $noFilters = $('.custom-prod-filter.custom-prod-filter--' + key + ' .custom-prod-filter__no-filters');
  //     let html = '';

  //     this.filterProps[key].forEach(filterProp => {
  //       html += '<div class="active-filter">';
  //       html += filterProp;
  //       html += '<i class="icon icon-close"></i></div>';  
  //     })

  //     if (html !== '') {
  //       $noFilters.removeClass('active');
  //       $('.custom-prod-filter.custom-prod-filter--' + key + ' .custom-prod-filter__active-filters').html(html);
  //     } else {
  //       $noFilters.addClass('active');
  //     }
  //   });

  //   // go trough all active filters and set active class 
  //   Object.keys(this.filterProps).forEach((filterType) => {
  //     const activeFilterTypes = this.filterProps[filterType];

  //     if (typeof activeFilterTypes !== undefined && activeFilterTypes.length > 0) {
  //       activeFilterTypes.forEach(filterOptionName => {
  //         let $filterOptions = $('.custom-prod-filter--' + filterType + ' .filter-options-menu--level-0 .filter-option[data-name="'+filterOptionName + '"]');

  //         $filterOptions.addClass('active');
  //       })
  //     }
  //   });
  // },
  initSelectedFilters() {
    // click on filter tag removes active filter tag
    $('.custom-prod-filter .custom-prod-filter__active-filters').on('click', '.active-filter', (event) => {
      let $self = $(event.target).closest('.active-filter');
      let filterSlug = $self.data('filter-slug');
      let filterType = $self.closest('.custom-prod-filter').data('filter-type');
      let $noFiltersMsg = $self.closest('.custom-prod-filter__no-filters');

      if (typeof this.filterProps[filterType] !== 'undefined') {
        let index = this.filterProps[filterType].indexOf(filterSlug);
        this.filterProps[filterType].splice(index, 1);

        if (this.filterProps[filterType].length === 0) {
          $noFiltersMsg.addClass('active');
        }

        this.updateURLFilters();
        $self.remove();
      }
    })
  },
  setFilterPropsFromURL() {
    let urlFilters = queryString.parse(window.location.search.substr(1));

    // merge two filter arrays without duplicates
    Object.keys(this.filterProps).forEach(key => {
      Object.keys(urlFilters).forEach(urlKey => {
        // console.log(urlKey, key);
        if ('tax_' + key === urlKey) {
          urlFilters[urlKey] = urlFilters[urlKey].split(',');
          urlFilters[urlKey] = [].concat(urlFilters[urlKey]);

          urlFilters[urlKey].forEach(urlFilterProp => {
            if (!this.filterProps[key].includes(urlFilterProp)) {
              this.filterProps[key].push(urlFilterProp);
            }
          })
        }
      });
    })
  }
}


// WEBPACK FOOTER //
// ./scripts/archiveFilters.js